var ChapterDoc, ChapterDocShape, DOCUMENT_SECTIONS_V2_SECTION_TYPE, DocumentSectionsV2Actions, MDA_HANDOUT, MINI_DOCUMENT_DOC_TYPE, MINI_DOC_TEMPLATES, MINI_DS_CHAPTER_PREFIX, MINI_DS_PREFIX, MINI_DS_ROOT_PREFIX, MINI_DS_SECTION_PREFIX, MdaTopicDoc, MiniDSDoc, MiniDSRootDoc, QuestionsStatusesActions, SectionDoc, SectionDocShape, W, alt, callMethod, chaptersView, createChaptersStructure, deriveHandoutIdFromTopicId, discussionsDbView, errorHandlerWithMsg, generateActions, generateGUID, kebabCase, mediator, prepareSubchapters, _ref, _ref1, _ref2;

alt = require('alt');

ChapterDoc = require('lib/db_docs/document_sections_v2_chapter_doc');

ChapterDocShape = require('lib/db_docs/doc_shapes/document_sections_v2_chapter_doc_shape');

SectionDoc = require('lib/db_docs/document_sections_v2_section_doc');

DocumentSectionsV2Actions = require('actions/document_sections_v2_actions');

generateActions = require('actions/utils/generate_actions');

_ref = require('lib/db_docs/doc_types'), MDA_HANDOUT = _ref.MDA_HANDOUT, MINI_DOCUMENT_DOC_TYPE = _ref.MINI_DOCUMENT_DOC_TYPE, DOCUMENT_SECTIONS_V2_SECTION_TYPE = _ref.DOCUMENT_SECTIONS_V2_SECTION_TYPE;

kebabCase = require('lodash').kebabCase;

MdaTopicDoc = require('lib/db_docs/mda_topic_doc');

MiniDSDoc = require('lib/db_docs/mini_ds_doc');

MiniDSRootDoc = require('lib/db_docs/mini_ds_root_doc');

mediator = require('mediator');

QuestionsStatusesActions = require('actions/questions_statuses_actions');

SectionDocShape = require('lib/db_docs/doc_shapes/document_sections_v2_section_doc_shape');

MINI_DOC_TEMPLATES = require('lib/document_sections_v2_templates/templates');

W = require('when/when');

errorHandlerWithMsg = require('lib/app_utils').errorHandlerWithMsg;

_ref1 = require('base/lib/utils'), callMethod = _ref1.callMethod, generateGUID = _ref1.generateGUID;

_ref2 = require('lib/doc_prefixes'), MINI_DS_PREFIX = _ref2.miniDsDoc, MINI_DS_ROOT_PREFIX = _ref2.miniDSRootDoc, MINI_DS_CHAPTER_PREFIX = _ref2.miniDSChapterDoc, MINI_DS_SECTION_PREFIX = _ref2.miniDSSectionDoc;

deriveHandoutIdFromTopicId = require('lib/mda_handouts_helper').deriveHandoutIdFromTopicId;

discussionsDbView = require('lib/document_sections_v2_helper').discussionsDbView;

chaptersView = {
  map: function(doc) {
    if (doc.type === 'document_sections_chapter') {
      return emit(doc.parentDocId, doc);
    }
  }
};

prepareSubchapters = function(mainDocId, chapter, chapterId) {
  var documents, nestedDocs, sectionDoc, subchapterDoc, subchapterId, _chapter, _i, _len, _ref3;
  if (!chapter.chapters) {
    return [];
  }
  documents = [];
  _ref3 = chapter.chapters;
  for (_i = 0, _len = _ref3.length; _i < _len; _i++) {
    _chapter = _ref3[_i];
    subchapterId = "" + MINI_DS_CHAPTER_PREFIX + (generateGUID());
    nestedDocs = prepareSubchapters(mainDocId, _chapter, subchapterId);
    sectionDoc = _.has(_chapter, "content") ? SectionDocShape.defaults({
      _id: "" + MINI_DS_SECTION_PREFIX + (generateGUID()),
      parent: subchapterId,
      title: '',
      content: _chapter.content
    }) : null;
    subchapterDoc = ChapterDocShape.defaults({
      _id: subchapterId,
      parent: chapterId,
      slug: kebabCase(_chapter.title),
      sections: sectionDoc ? [sectionDoc._id] : [],
      title: $.t("docsec:templates.chapters." + _chapter.title),
      parentDocId: mainDocId,
      subchapters: _.chain(nestedDocs).filter((function(_this) {
        return function(_arg) {
          var parent, type;
          parent = _arg.parent, type = _arg.type;
          return parent === subchapterId && type !== DOCUMENT_SECTIONS_V2_SECTION_TYPE;
        };
      })(this)).pluck('_id').value()
    });
    if (sectionDoc) {
      documents.push(sectionDoc);
    }
    documents.push(subchapterDoc);
    documents.push.apply(documents, nestedDocs);
  }
  return documents;
};

createChaptersStructure = function(doc) {
  var chapterDocuments, parentDocId, template;
  parentDocId = doc._id;
  template = _.find(MINI_DOC_TEMPLATES, function(docTpl) {
    return docTpl.id === 'mda_template';
  });
  chapterDocuments = prepareSubchapters(parentDocId, template, null);
  return {
    rootChapterIds: _.map(chapterDocuments.filter(function(chDoc) {
      return !chDoc.parent;
    }), function(chDoc) {
      return chDoc._id;
    }),
    docs: chapterDocuments
  };
};

module.exports = generateActions({
  autoGenerate: ['closeCreateOrEditDialog', 'fetchSuccess', 'openCreateOrEditDialog'],
  name: 'MiniDSActions',
  actions: {
    dbChange: function(change, _pending, _lastSeq) {
      var currentDocumentId, _ref3, _ref4, _ref5, _ref6;
      currentDocumentId = alt.stores.MiniDSStore.getCurrentDocumentId();
      if (change.deleted || ((_ref3 = change.doc) != null ? _ref3._id : void 0) === currentDocumentId || ((_ref4 = change.doc) != null ? _ref4.docType : void 0) === MINI_DOCUMENT_DOC_TYPE || ((_ref5 = change.doc) != null ? _ref5.type : void 0) === DOCUMENT_SECTIONS_V2_SECTION_TYPE) {
        DocumentSectionsV2Actions.dbChange(change);
      }
      QuestionsStatusesActions.dbChange(change);
      if (((_ref6 = change.doc) != null ? _ref6._id : void 0) === currentDocumentId) {
        return this.dispatch(change);
      }
    },
    fetch: function(_arg) {
      var adapter, dbId, docId;
      dbId = _arg.dbId, docId = _arg.docId;
      this.dispatch();
      adapter = mediator.services.storePersistenceAdapter;
      return MiniDSDoc.at(dbId, docId).fetch().then((function(_this) {
        return function(doc) {
          var chaptersPromise, discussionsPromise, rootPromise;
          rootPromise = MiniDSRootDoc.at(dbId, doc.docRootId).fetch();
          chaptersPromise = adapter.fetchWithView(dbId, 'chaptersView', chaptersView, docId);
          discussionsPromise = adapter.fetchWithView(dbId, 'doc_sec_v2_discussions', discussionsDbView, docId);
          return W.all([rootPromise, chaptersPromise, discussionsPromise]).then(function(_arg1) {
            var chapters, discussions, root;
            root = _arg1[0], chapters = _arg1[1], discussions = _arg1[2];
            DocumentSectionsV2Actions.fetchSuccess({
              alreadyUsedRecommendations: [],
              chapters: chapters,
              discussions: discussions,
              docId: docId,
              recommendations: [],
              root: root
            });
            return _this.actions.fetchSuccess(doc);
          });
        };
      })(this))["catch"](DocumentSectionsV2Actions.fetchFailure);
    },
    createDocument: function(doc, options) {
      var docToCreate, parentTopicId, _ref3;
      this.dispatch();
      parentTopicId = doc != null ? (_ref3 = doc.options) != null ? _ref3.parentTopicId : void 0 : void 0;
      if (options.docType === MDA_HANDOUT && _.isEmpty(parentTopicId)) {
        mediator.dialogs.error($.t('docsec:mini_ds.missing_parent_topic_error'));
        this.actions.closeCreateOrEditDialog();
        return;
      }
      docToCreate = _.extend({}, doc, options, {
        _id: options.docType === MDA_HANDOUT ? deriveHandoutIdFromTopicId(parentTopicId) : "" + MINI_DS_PREFIX + (generateGUID()),
        docRootId: "" + MINI_DS_ROOT_PREFIX + (generateGUID())
      });
      return MiniDSDoc.at(mediator.project.id).create(docToCreate).then(function(createdDoc) {
        if (docToCreate.docType === MDA_HANDOUT) {
          return MdaTopicDoc.at(mediator.project.id, parentTopicId).updateAsInstance(callMethod('addHandout', createdDoc._id))["catch"](function(err) {
            return errorHandlerWithMsg(err, $.t('docsec:mini_ds.handout_link_error'));
          }).then(function() {
            return createdDoc;
          });
        } else {
          return createdDoc;
        }
      }).then(this.actions.createDocumentDoc).then(function() {
        if (docToCreate.docType === MDA_HANDOUT) {
          return QuestionsStatusesActions.updateQuestionStatus(mediator.project.id, docToCreate._id, 'handoutStatus', 'handoutCreated');
        }
      })["catch"](function(err) {
        return errorHandlerWithMsg(err, $.t('docsec:mini_ds.create_error'));
      })["finally"](this.actions.closeCreateOrEditDialog);
    },
    createDocumentDoc: function(doc) {
      var chapterDocs;
      chapterDocs = createChaptersStructure(doc);
      return MiniDSRootDoc.at(mediator.project.id).create({
        _id: doc.docRootId,
        chaptersOrder: chapterDocs.rootChapterIds,
        parentDocId: doc._id
      }).then(function() {
        var chapters, sections, _ref3;
        _ref3 = _.partition(chapterDocs.docs, function(d) {
          return d.type === 'document_sections_chapter';
        }), chapters = _ref3[0], sections = _ref3[1];
        return W.all([ChapterDoc.at(mediator.project.id).createMany(chapters), SectionDoc.at(mediator.project.id).createMany(sections)]);
      })["catch"](function(err) {
        return errorHandlerWithMsg(err, $.t('docsec:mini_ds.create_doc_root_error'));
      });
    },
    updateDocument: function(doc) {
      this.dispatch();
      return MiniDSDoc.at(mediator.project.id, doc._id).update(doc)["catch"](function(err) {
        return errorHandlerWithMsg(err, $.t('docsec:mini_ds.save_error'));
      })["finally"]((function(_this) {
        return function() {
          return _this.actions.closeCreateOrEditDialog();
        };
      })(this));
    }
  }
});
